import { ToolStates } from './ToolStates';
import { NavigationStates } from './NavigationStates';
import { SwitchingState } from './SwitchingState';
import { ToolCategoryState } from './ToolCategoryState';
import { NotifState } from './NotifState';
import { HomeStates } from './HomeState';
import { ExamState } from './ExamState';
import { ProviderState, SpeakerState } from './FacilitatorState';
import { ReportCourseState, ReportTrainingState } from './ReportsState';
import { TrainingState, TrainingTopicState, TrainingVideoState } from './TrainingState';
import { CertificatesState } from './CertificatesState';
import { InformationState } from './InformationState';
import { PersonalizationState } from './PerzonalizationState';
import { UsageOverviewState } from './UsageOverviewState';
import { ProfileState } from './ProfileState';

export const Context = () => {
    return {
        tool_state: ToolStates(),
        navigation_state: NavigationStates(),
        switching_state: SwitchingState(),
        tool_category_state: ToolCategoryState(),
        notif_state: NotifState(),
        home_state: HomeStates(),
        exam_state: ExamState(),
        speaker_state: SpeakerState(),
        provider_state: ProviderState(),
        training_report_state: ReportTrainingState(),
        course_report_state: ReportCourseState(),
        training_video_state: TrainingVideoState(),
        training_topic_state: TrainingTopicState(),
        training_state: TrainingState(),
        certificates_state: CertificatesState(),
        information_state: InformationState(),
        personalization_state: PersonalizationState(),
        usage_state: UsageOverviewState(),
        profile_state: ProfileState(),
    }
}